import React from 'react';
import { CheckCircle, Clock, UsersThree } from '@phosphor-icons/react';

export const MatchPlayersPaid = ({ booking, L }) => {
  const players = booking.match_players || [];
  const max = booking.match_max_players || 4;
  const per = booking.match_cost_per_player || 0;
  const paidCount = players.filter(p => p.paid).length;
  const openSlots = Math.max(0, max - players.length);
  return (
    <div className="mt-4 rounded-xl border border-sky-200 bg-sky-50/60 p-4" data-testid="match-players-paid">
      <div className="flex items-center justify-between mb-2">
        <p className="font-bold text-sky-900 text-sm flex items-center gap-1.5">
          <UsersThree size={16} weight="duotone" /> {L('Open Match players', 'Open-Match Spieler')}
        </p>
        <span className="text-xs font-semibold text-sky-800" data-testid="match-paid-count">
          {paidCount}/{max} {L('paid', 'bezahlt')} · {per.toFixed(2)} CHF {L('each', 'p.P.')}
        </span>
      </div>
      <div className="space-y-1.5">
        {players.map(p => (
          <div key={p.id} className="flex items-center justify-between bg-white rounded-lg px-3 py-2 text-sm" data-testid={`match-player-${p.id}`}>
            <span className="font-medium text-slate-800 truncate">{p.name}</span>
            {p.paid ? (
              <span className="flex items-center gap-1 text-emerald-700 font-semibold text-xs shrink-0" data-testid={`match-player-paid-${p.id}`}>
                <CheckCircle size={14} weight="fill" />
                {p.payment_method === 'online' ? L('Paid online', 'Online bezahlt') : L('Paid', 'Bezahlt')}
              </span>
            ) : (
              <span className="flex items-center gap-1 text-amber-700 font-semibold text-xs shrink-0" data-testid={`match-player-open-${p.id}`}>
                <Clock size={14} /> {L('Open', 'Offen')}
              </span>
            )}
          </div>
        ))}
        {openSlots > 0 && (
          <p className="text-xs text-slate-500 px-1">{openSlots} {L('spot(s) still free', 'Platz/Plätze noch frei')}</p>
        )}
      </div>
    </div>
  );
};
